<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     [attr.width]="size.width + 'px'"
     [attr.height]="size.height + 'px'"
     [attr.stroke-width]="strokeWidth"
     stroke-linecap="round"
     viewBox="0 0 24 24">
  <g [attr.fill]="color" [attr.stroke]="color">
    <path d="M13 12L24 23 23 24 12 13 1 24 0 23 11 12 0 1 1 0 12 11 23 0 24 1 13 12Z"/>
  </g>
</svg>
